import { render, staticRenderFns } from "./ExamInfo.vue?vue&type=template&id=10677793&"
import script from "./ExamInfo.vue?vue&type=script&lang=js&"
export * from "./ExamInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports